import { ISearchQuery, SearchRepository } from '../repositories/SearchRepository';

export class SearchTypeaheadUseCase {
    private searchRepository: SearchRepository;

    constructor(searchRepository: SearchRepository) {
        this.searchRepository = searchRepository;
    }

    public execute = async (searchQuery: ISearchQuery) => {
        try {
            await this.searchRepository.getTypeaheadResults(searchQuery);
        } catch (error) {
            console.error(error);
        }
    };
}
